
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("kQ0Cq"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("kQ0Cq", function(module, exports) {

let $f2b924dbddbace79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2b924dbddbace79$var$load("h3ABO"),
    $f2b924dbddbace79$var$load("9hYRW"),
    $f2b924dbddbace79$var$load("kpm7S"),
    $f2b924dbddbace79$var$load("5wC2D"),
    $f2b924dbddbace79$var$load("2YffH"),
    $f2b924dbddbace79$var$load("g7ggm"),
    $f2b924dbddbace79$var$load("eEyVs"),
    $f2b924dbddbace79$var$load("6mHrv"),
    $f2b924dbddbace79$var$load("awWN9"),
    $f2b924dbddbace79$var$load("9CYct"),
    $f2b924dbddbace79$var$load("80qAe"),
    $f2b924dbddbace79$var$load("9hf2S"),
    $f2b924dbddbace79$var$load("hZtKG"),
    $f2b924dbddbace79$var$load("dkqvW"),
    $f2b924dbddbace79$var$load("lVO3w"),
    $f2b924dbddbace79$var$load("hyzoX"),
    $f2b924dbddbace79$var$load("h9Ed7"),
    $f2b924dbddbace79$var$load("eBRUf"),
    $f2b924dbddbace79$var$load("kbRvk"),
    $f2b924dbddbace79$var$load("tKhaz"),
    $f2b924dbddbace79$var$load("hwT9D"),
    $f2b924dbddbace79$var$load("j4Bpe"),
    $f2b924dbddbace79$var$load("cD6Zr"),
    $f2b924dbddbace79$var$load("k3jER"),
    $f2b924dbddbace79$var$load("9wzNh"),
    $f2b924dbddbace79$var$load("8YSo7"),
    $f2b924dbddbace79$var$load("9ldRJ"),
    $f2b924dbddbace79$var$load("50ame"),
    $f2b924dbddbace79$var$load("7do1E"),
    $f2b924dbddbace79$var$load("77dkW"),
    $f2b924dbddbace79$var$load("1MlIV"),
    $f2b924dbddbace79$var$load("6iz6l"),
    $f2b924dbddbace79$var$load("4SCW2"),
    $f2b924dbddbace79$var$load("eukPA"),
    $f2b924dbddbace79$var$load("9QSJH"),
    $f2b924dbddbace79$var$load("Wowvf"),
    $f2b924dbddbace79$var$load("421lv"),
    $f2b924dbddbace79$var$load("dek7I"),
    $f2b924dbddbace79$var$load("3SmkN"),
    $f2b924dbddbace79$var$load("dYtBN"),
    $f2b924dbddbace79$var$load("kNV5Y"),
    $f2b924dbddbace79$var$load("6wr18"),
    $f2b924dbddbace79$var$load("kjZZD"),
    $f2b924dbddbace79$var$load("99Ppz"),
    $f2b924dbddbace79$var$load("5v2fx"),
    $f2b924dbddbace79$var$load("3JSgG"),
    $f2b924dbddbace79$var$load("37ldp"),
    $f2b924dbddbace79$var$load("ffEVr"),
    $f2b924dbddbace79$var$load("9AXkC"),
    $f2b924dbddbace79$var$load("28arV"),
    $f2b924dbddbace79$var$load("hhss7"),
    $f2b924dbddbace79$var$load("lkwGP"),
    $f2b924dbddbace79$var$load("fGPXi"),
    $f2b924dbddbace79$var$load("dP7ao"),
    $f2b924dbddbace79$var$load("hogcU"),
    $f2b924dbddbace79$var$load("dkgtP"),
    $f2b924dbddbace79$var$load("g43Ev"),
    $f2b924dbddbace79$var$load("7EorR"),
    $f2b924dbddbace79$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.1a73e3a0.js.map
